import { useEffect } from 'react';

// The Metas page keeps its overview in local state, out of reach of an SWR revalidation, so a goal
// changed somewhere else on screen (a write the chat confirmed) announces itself on the window.
const GOALS_CHANGED = 'vertice:goals-changed';

export function announceGoalsChanged(): void {
  window.dispatchEvent(new Event(GOALS_CHANGED));
}

export function useGoalsChanged(onChange: () => void): void {
  useEffect(() => {
    window.addEventListener(GOALS_CHANGED, onChange);
    return () => window.removeEventListener(GOALS_CHANGED, onChange);
  }, [onChange]);
}
